import * as management from './management';
import * as managementDetail from './managementDetail';
import * as specials from './specials';
import * as stockOrders from './stockOrders';
import * as manualOrders from './manualOrders';
import * as sequenceConfig from './sequenceConfig';
import * as amountReport from './amountReport';
import * as amountTotals from './amountTotals';
import * as AuthorizationOrders from './authorization';
import * as Importations from './importations';

export const Actions = {
  ...management,
  ...managementDetail,
  ...specials,
  ...stockOrders,
  ...manualOrders,
  ...sequenceConfig,
  ...amountReport,
  ...amountTotals,
  ...AuthorizationOrders,
  ...Importations,
};
